import React, { type ReactNode, useCallback } from 'react';

import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import { ButtonMenuItem } from '@atlaskit/side-nav-items/button-menu-item';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { useRovoNavigation } from '@atlassian/conversation-assistant/controllers/rovo-navigation';
import { FormattedMessage } from 'react-intl';

import { useAssistanceServiceParams } from '@townsquare/rovo/hooks';
import { useHandleOpenPanel } from '@townsquare/rovo-chat/hooks';
import { fg } from '@townsquare/stat-sig/gate';

import { useViewAllConversations } from './use-view-all-conversations';

export const ViewAllConversations = (): ReactNode => {
	const { handleClosePanel, isRovoSidebarOpen } = useHandleOpenPanel();

	const assistanceServiceParams = useAssistanceServiceParams({
		experienceId: 'ai-mate',
		touchpointSource: 'townsquare-sidenav',
	});
	const { handleViewAllConversationsClick } = useRovoNavigation({
		assistanceServiceParams,
		isTasksEnabled: fg('rovo_chat_enable_tasks'),
	});

	const closeRovoSidebar = useCallback(() => {
		if (isRovoSidebarOpen) {
			handleClosePanel();
		}
	}, [handleClosePanel, isRovoSidebarOpen]);

	const onViewAllConversations = useViewAllConversations({
		closeRovoSidebar,
		handleViewAllConversationsClick,
	});

	return (
		<MenuList>
			<ButtonMenuItem
				elemBefore={<AlignTextLeftIcon label="" color="currentColor" />}
				onClick={onViewAllConversations}
			>
				<FormattedMessage
					id="townsquare.rovo-side-nav.view-all-conversations.label"
					defaultMessage="View all conversations"
					description="Button which takes you to a page to view all your conversations with Rovo"
				/>
			</ButtonMenuItem>
		</MenuList>
	);
};
